import { render, staticRenderFns } from "./AttendanceBookPopup.vue?vue&type=template&id=096a661c&scoped=true&"
import script from "./AttendanceBookPopup.vue?vue&type=script&lang=ts&"
export * from "./AttendanceBookPopup.vue?vue&type=script&lang=ts&"
import style0 from "./AttendanceBookPopup.vue?vue&type=style&index=0&id=096a661c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096a661c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCheckbox,VDataTable,VImg})
